let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jRRRZ")).then(() => parcelRequire('6dj0L'));